'use strict';
import axios from 'axios';
import store from '../store';

export default class Order {
	static getOrder(pin, pinToken, iccid, changeReason, urlEsim, biometryAccepted) {
		if (process.env.NODE_ENV === 'development')
			return this.developmentPostOrder(
				pin,
				pinToken,
				iccid,
				changeReason,
				urlEsim,
				biometryAccepted
			);
		return axios.get(`../${store.getters.getConfig['order_url']}`, {
			headers: {
				access_key: store.getters.getAccessKey,
				metadata: store.getters.getMetadataCookie,
			},
			params: {
				pin: pin,
				pinToken: pinToken,
				iccid: iccid,
				changeReason: changeReason,
				urlEsim: urlEsim,
				biometryAccepted: biometryAccepted
			},
		});
	}

	static developmentPostOrder(pin, pinToken, iccid, changeReason, urlEsim, biometryAccepted) {
		return axios.get('/api/order', {
			params: {
				pin: pin,
				pinToken: pinToken,
				iccid: iccid,
				changeReason: changeReason,
				urlEsim: urlEsim,
				biometryAccepted: biometryAccepted
			},
		});
	}
}
